import { z } from 'zod';
import { DEFAULT_WEB_FORM_FIELDS, WEB_FORM_MAX_FIELDS, webFormFieldConfigSchema } from '../web-forms/fields.js';
const fieldsSchema = z
    .array(webFormFieldConfigSchema)
    .max(WEB_FORM_MAX_FIELDS)
    .refine((fields) => new Set(fields.map((f) => f.key)).size === fields.length, {
    message: 'Each field can only be added to a form once.',
});
export const createWebFormSchema = z.object({
    name: z.string().trim().min(1).max(120),
    fields: fieldsSchema.default(DEFAULT_WEB_FORM_FIELDS),
    successHeadline: z.string().trim().min(1).max(120).default("Thanks — we've got it"),
    successMessage: z.string().trim().min(1).max(300).default('Someone from our team will be in touch shortly.'),
    redirectUrl: z.string().trim().url().max(500).optional(),
    sourceId: z.string().uuid().optional(),
});
export const updateWebFormSchema = z.object({
    name: z.string().trim().min(1).max(120).optional(),
    fields: fieldsSchema.optional(),
    successHeadline: z.string().trim().min(1).max(120).optional(),
    successMessage: z.string().trim().min(1).max(300).optional(),
    redirectUrl: z.string().trim().url().max(500).nullable().optional(),
    sourceId: z.string().uuid().nullable().optional(),
    isActive: z.boolean().optional(),
});
export const webFormResponseSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    publicKey: z.string(),
    fields: z.array(webFormFieldConfigSchema),
    successHeadline: z.string(),
    successMessage: z.string(),
    redirectUrl: z.string().nullable(),
    sourceId: z.string().uuid().nullable(),
    sourceName: z.string().nullable(),
    isActive: z.boolean(),
    submissionCount: z.number().int(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=web-forms.js.map